<template>
  <footer class="footer">
    <div class="footer-container">
      <div class="footer-note">
        <p>
          &copy; 2026
          <a href="/" class="footer-link">aeroswap.org</a>
          — Guides and news about WhatsApp Aero. All rights belong to their owners.
        </p>
      </div>
      <div class="footer-links">
        <a href="/disclaimer/" class="footer-link footer-link--small">Disclaimer</a>
        <span class="footer-divider" aria-hidden="true"></span>
        <a href="/privacy-policy/" class="footer-link footer-link--small">Privacy Policy</a>
        <span class="footer-divider" aria-hidden="true"></span>
        <a href="/terms/" class="footer-link footer-link--small">Terms & Conditions</a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
};
</script>

<style lang="scss" scoped>
.footer {
  background-color: #2c3338;
  color: #ccc;
  padding: 24px 0 20px;
  margin-top: 32px;
}

.footer-container {
  width: min(1080px, 94%);
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  text-align: center;
}

.footer-note {
  font-size: 14px;

  p {
    margin: 0;
    line-height: 1.5;
  }
}

.footer-links {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 0;
}

.footer-link {
  color: #8cc37a;
  text-decoration: none;
  transition: color 0.2s;

  &:hover {
    color: #fff;
  }

  &--small {
    font-size: 12px;
    padding: 0 12px;
  }
}

.footer-divider {
  display: inline-block;
  width: 1px;
  height: 12px;
  background: rgba(255, 255, 255, 0.25);
  flex-shrink: 0;
}

@media (max-width: 768px) {
  .footer {
    padding: 16px 0 56px;
  }

  .footer-note {
    font-size: 12px;
  }

  .footer-link--small {
    font-size: 11px;
    padding: 0 10px;
  }
}
</style>
